export default __webpack_public_path__ + "static/media/contact-stairs-light.65a28ccc.svg";